export default __webpack_public_path__ + "static/media/nittLogoWide.54460003.png";